/**
 * Returns the list of available subscriptions with their appropriate Stripe IDs, depending on the environment.
 * 
 * @param devMode whether we are in development mode
 */
const subscriptions = (devMode) => ([
    {
        name: 'DataGrab Personal',
        plan: 'personal',
        billingInterval: 'monthly',
        stripeProdId: devMode ? 'prod_KDIwEIAVzFRiso' : 'prod_KGkSgbZK0BjTxt',
        stripePriceId: devMode ? 'price_1JYsKrBVjwweZvrJgzjhNwhs' : 'price_1JcCxoBVjwweZvrJRCx51kDQ',
        monthlyPrice: 29,
        monthlyCredits: 5000,
        concurrency: 2,
    },
    {
        name: 'DataGrab Personal',
        plan: 'personal',
        billingInterval: 'yearly',
        stripeProdId: devMode ? 'prod_KDIwEIAVzFRiso' : 'prod_KGkSgbZK0BjTxt',
        stripePriceId: devMode ? 'price_1JYsKrBVjwweZvrJ8s271rMc' : 'price_1JcCxoBVjwweZvrJOJUn28qv',
        monthlyPrice: 25,
        monthlyCredits: 5000,
        concurrency: 2,
    },
    {
        name: 'DataGrab Business',
        plan: 'business',
        billingInterval: 'monthly',
        stripeProdId: devMode ? 'prod_KDJ0YhaoTlxrKc' : 'prod_KGkSaB5UCqIGhB',
        stripePriceId: devMode ? 'price_1JYsOdBVjwweZvrJZywg0qbd' : 'price_1JcCy0BVjwweZvrJ66GHtyos',
        monthlyPrice: 99,
        monthlyCredits: 50000,
        concurrency: 3,
    },
    {
        name: 'DataGrab Business',
        plan: 'business',
        billingInterval: 'yearly',
        stripeProdId: devMode ? 'prod_KDJ0YhaoTlxrKc' : 'prod_KGkSaB5UCqIGhB',
        stripePriceId: devMode ? 'price_1JYsOdBVjwweZvrJ3Z1slDZ8' : 'price_1JcCy0BVjwweZvrJ6BfsID6K',
        monthlyPrice: 80,
        monthlyCredits: 50000,
        concurrency: 3,
    },
    {
        name: 'DataGrab Enterprise',
        plan: 'enterprise',
        billingInterval: 'monthly',
        stripeProdId: devMode ? 'prod_KDJ1jRbH5uIkLy' : 'prod_KGkTY6SQsVC5AE',
        stripePriceId: devMode ? 'price_1JYsPlBVjwweZvrJmQkYdxfi' : 'price_1JcCy6BVjwweZvrJ8bJMFal4',
        monthlyPrice: 249,
        monthlyCredits: 200000,
        concurrency: 5,
    },
    {
        name: 'DataGrab Enterprise',
        plan: 'enterprise',
        billingInterval: 'yearly',
        stripeProdId: devMode ? 'prod_KDJ1jRbH5uIkLy' : 'prod_KGkTY6SQsVC5AE',
        stripePriceId: devMode ? 'price_1JYsPlBVjwweZvrJ6i7b8Ezp' : 'price_1JcCy6BVjwweZvrJGELJTvz5',
        monthlyPrice: 200,
        monthlyCredits: 200000,
        concurrency: 5,
    }
])

/**
 * Returns the list of available bulk credit packages with their appropriate Stripe IDs, depending on the environment.
 *
 * @param devMode whether we are in development mode
 */
const bulkCredits = (devMode) => ([
    {
        code: 'x1000',
        name: 'DataGrab x1000',
        stripeProdId: devMode ? 'prod_KF8nJ3kmkCtfja' : 'prod_KGkT4IjMicPtFf',
        stripePriceId: devMode ? 'price_1JaeVrBVjwweZvrJ5F8PNVT3' : 'price_1JcCyNBVjwweZvrJhYqV6EKw',
        price: 10,
        amount: 1000
    },
    {
        code: 'x10k',
        name: 'DataGrab x10000',
        stripeProdId: devMode ? 'prod_KF8rMcjYjfprF7' : 'prod_KGkTh3DnlAiZBh',
        stripePriceId: devMode ? 'price_1JaeZLBVjwweZvrJ9BocP2AX' : 'price_1JcCyVBVjwweZvrJW1QiO0Wf',
        price: 50,
        amount: 10000
    },
    {
        code: 'x50k',
        name: 'DataGrab x50000',
        stripeProdId: devMode ? 'prod_KF8sRyRzbDpduO' : 'prod_KGkTqsCxndgNOc',
        stripePriceId: devMode ? 'price_1Jaeb9BVjwweZvrJFXw1yK71' : 'price_1JcCycBVjwweZvrJgpdGfNmg',
        price: 150,
        amount: 50000
    },
    {
        code: 'x100k',
        name: 'DataGrab x100000',
        stripeProdId: devMode ? 'prod_KF8uBXguSQtYSt' : 'prod_KGkTJpzdHzorgd',
        stripePriceId: devMode ? 'price_1JaecSBVjwweZvrJTcdTzyaP' : 'price_1JcCyhBVjwweZvrJizRM6Uy8',
        price: 250,
        amount: 100000
    }
])

/**
 * Returns the maximum allow concurrency settings for a given number of available bulk credits.
 * @param credits the number of available credits
 */
const maxConcurrencyForCredits = (credits) => {
    if (credits >= 50000)  return 5
    if (credits >= 10000)  return 3
    if (credits >= 2000)  return 2
    return 1
}


module.exports = {subscriptions, bulkCredits, maxConcurrencyForCredits}